import { render, staticRenderFns } from "./CardFila.vue?vue&type=template&id=1adb898c&"
import script from "./CardFila.vue?vue&type=script&lang=js&"
export * from "./CardFila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports